var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9062 17.125H1.09375C0.601562 17.125 0.25 16.7734 0.25 16.2812C0.25 15.8242 0.601562 15.4375 1.09375 15.4375H12.9062C13.3633 15.4375 13.75 15.8242 13.75 16.2812C13.75 16.7734 13.3633 17.125 12.9062 17.125ZM6.36719 12.3789L1.86719 7.59766C1.55078 7.24609 1.58594 6.71875 1.90234 6.40234C2.25391 6.08594 2.78125 6.08594 3.09766 6.4375L6.15625 9.67188V6.71875V2.21875C6.15625 1.76172 6.50781 1.375 7 1.375C7.45703 1.375 7.84375 1.76172 7.84375 2.21875V6.71875V9.67188L10.8672 6.4375C11.1836 6.08594 11.7109 6.08594 12.0625 6.40234C12.4141 6.71875 12.4141 7.24609 12.0977 7.59766L7.59766 12.3789C7.42188 12.5547 7.21094 12.625 7 12.625C6.75391 12.625 6.54297 12.5547 6.36719 12.3789Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLight);
export default __webpack_public_path__ + "static/media/download_light.3629ddc3f39b1a1fe774ce06904c8bd2.svg";
export { ForwardRef as ReactComponent };